@if (mixingEvent?.status === 'in_progress') {
  <span class="flex gap-2 items-center">
    <span>
      <ng-container i18n="@@stage">Stage</ng-container>
      {{ mixingEvent.currentStageIndex + 1 }}
      <ng-container i18n="@@of">of</ng-container>
      {{ mixingEvent.speedPattern.length }}</span
    >
  </span>
} @else if (mixingEvent?.status === 'success') {
  <span class="flex gap-2 items-center">
    <span i18n="@@complete">Complete</span>
  </span>
} @else if (mixingEvent?.status === 'fail') {
  <span class="flex gap-2 items-center">
    <span i18n="@@incomplete">Incomplete</span>
  </span>
}
